import { Button } from 'components/buttons/Button';
import { SearchBox } from 'components/filters/SearchBox';
import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React from 'react';
import { useTableColumns } from './hooks/useTableColumns';
import { useTableData } from './hooks/useTableData';

import "assets/scss/billingPortal/modules/activityLog.scss";
import { convertArrayToDropdownArrayFormat, isObjectEmpty, isObjectNotEmpty } from 'functions';
import { MultiFilters } from 'components/filters/MultiFilters';

function ActivityLog(props) {

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");
    
    const {
        getData,
        data, 
        isDataLoading,
        totalRecords
    } = useTableData();

    const columns = useTableColumns();

    return (
        <DashboardLayout
            headerTitle={"Activity Log"}

            bodyClassName={"activity-log"}
            body={(
                <GeneralTable
                    className={"activity-log__table"}
                    columns={columns}
                    data={userPermissions?.Internal_General_ViewActivityLog? data: []}

                    getTableData={getData}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        List
                                    </div>
                                </div>

                                {/* Bottom Section */}
                                <div className={"headers__bottom-section"}>
                                    <MultiFilters
                                        defaultFilterOption={{
                                            label: "Username", 
                                            propertyName: "loggerUser",
                                            placeholder: "Username",
                                            inputType: "search",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "Username", 
                                                propertyName: "loggerUser",
                                                placeholder: "Username",
                                                inputType: "search",
                                            },
                                            {
                                                label: "Module", 
                                                propertyName: "module",
                                                placeholder: "Module",
                                                options: [
                                                    {
                                                        label: "Invoice",
                                                        value: "invoice"
                                                    },
                                                    {
                                                        label: "Billing Setup",
                                                        value: "billingsetup"
                                                    },
                                                    {
                                                        label: "User",
                                                        value: "user"
                                                    },
                                                    {
                                                        label: "Company Info",
                                                        value: "compInfo"
                                                    },
                                                    {
                                                        label: "General",
                                                        value: "general"
                                                    }
                                                ],
                                                inputType: "dropdown"
                                            },
                                            {
                                                label: "Reference Key", 
                                                propertyName: "referenceKey",
                                                placeholder: (filterOptions?.module === "invoice" || filterOptions?.module === "billingsetup"? "Enter Account Code":
                                                    filterOptions?.module === "user"? "Enter User Email":
                                                    filterOptions?.module === "compInfo"? "Enter COM ID":
                                                    filterOptions?.module === "general"? "Not Applicable":""),
                                                inputType: "search",
                                                isDisabled: filterOptions?.module === "general",
                                            },
                                            {
                                                label: "Date", 
                                                propertyName_start: "fromDate",
                                                propertyName_end: "toDate",
                                                placeholder_start: "Start",
                                                placeholder_end: "End",
                                                inputType: "dateRange",
                                                isNotUsingMonthYear: true
                                            }
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    }}
                    
                    isTableDataLoading={isDataLoading}

                    isUsingPagination
                    totalRecords={totalRecords}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}
        />
    );
}

export default ActivityLog;